import axios from 'axios'
const ApiProduccion = 'produccion/php/api/'

const get = (url) => {
	return axios.get(ApiProduccion + url)
}

const post = (url, data) => {
	return axios.post(ApiProduccion + url, data)
}

export default {
	// TAREAS

	/**
	 * Obtener un listado de tareas
	 */
	getListadoTareas: () => {
		return get('get-listado-tareas-new.php')
	},

	buscaTareas: (filtro) => {
		const form = JSON.parse(JSON.stringify(filtro))
		if (filtro.fechaIni) {
			filtro.fechaIni.setHours(0)
			filtro.fechaIni.setMinutes(0)
			filtro.fechaIni.setSeconds(0)
		}

		if (filtro.fechaFin) {
			filtro.fechaFin.setHours(23)
			filtro.fechaFin.setMinutes(59)
			filtro.fechaFin.setSeconds(59)
		}
		form.fechaIni = (filtro.fechaIni) ? Math.floor(filtro.fechaIni.getTime() / 1000) : null
		form.fechaFin = (filtro.fechaFin) ? Math.floor(filtro.fechaFin.getTime() / 1000) : null
		return post('buscaTareas.php', form)
	},

	/**
	 * Obtenemos la tarea pasando su ID
	 */
	getTarea: (idTarea) => {
		return get('get-tarea.php?ID_tarea=' + idTarea)
	},

	/**
	 * Editamos los datos de una tarea
	 */
	setTarea: (datos) => {
		return post('set-tarea.php', datos)
	},

	setTareaExpress: (datos) => {
		return post('set-tarea-express.php', datos)
	},

	/**
	 * Elimina una tarea en función de su ID
	 */
	delTarea: (idTarea) => {
		return get('del-tarea.php?ID_tarea=' + idTarea)
	},

	setTiempoEstimado: (idVersion, tiempo) => {
		const datos = {
			ID_version: idVersion,
			tiempo: tiempo
		}
		return post('set-tiempo-estimado.php', datos)
	},

	/**
	 * Añade un soporte a la tarea
	 */
	tareaAddSoporte: (datos) => {
		return post('tarea-add-soporte.php', datos)
	},

	/**
	 * Añade uno o más ficheros a la tarea
	 */
	tareaAddFicheros: (formData) => {
		return post('set-ficheros-tarea.php', formData)
	},

	/**
	 * Elimina un fichero de una tarea
	 */
	tareaDelFichero: (datos) => {
		return post('del-ficheros-tarea.php', datos)
	},

	/**
	 * Elimina un soporte de la tarea
	 */
	tareaDelSoporte: (datos) => {
		return post('tarea-del-soporte.php', datos)
	},

	/**
	 * Comentar en una tarea
	 */
	setComentarioTarea: (datos) => {
		return post('set-comentario-tarea.php', datos)
	},

	/**
	 * Obtenemos el historial de versiones
	 */
	getHistorial: (idTarea) => {
		return get('get-historial-tarea.php?ID_tarea=' + idTarea)
	},

	// PERMISOS
	getPermisos: () => {
		return get('get-permisos.php')
	},

	// CONTRATOS

	/**
	 * Buscamos contratos en base a un criterio
	 */
	buscaContratos: (filtro) => {
		return post('buscaContratos.php', filtro)
	},

	// PRODUCCIONES

	/**
	 * Obtenemos una producción en base a su id
	 */
	getProduccion: (idProduccion) => {
		return get('get-produccion.php?ID_produccion=' + idProduccion)
	},

	setProduccion: (datos) => {
		return post('set-produccion.php', datos)
	},

	/**
	 * Enviamos ficheros para la órden de producción
	 */
	setFicherosProduccion: (formData) => {
		return post('set-ficheros-produccion.php', formData)
	},

	delFicherosProduccion: (datos) => {
		return post('del-ficheros-produccion.php', datos)
	},

	// VERSIONES

	/**
	 * Crear/modificar un texto
	 */
	setTexto: (datos) => {
		return post('set-texto.php', datos)
	},

	/**
	 * Marcamos un texto como grabado o no
	 */
	setTextoGrabado: (datos) => {
		return post('set-texto-grabado.php', datos)
	},

	/**
	 * Elimina un texto
	 */
	delTexto: (datos) => {
		return post('del-texto.php', datos)
	},

	/**
	 * Elimina un fichero producido
	 */
	delFicheroVersion: (datos) => {
		return post('del-ficheros-version.php', datos)
	},

	/**
	 * Sube un fichero al XFrame
	 */
	setSubirXFrame: (datos) => {
		return post('set-subir-xframe.php', datos)
	},

	/**
	 * Envia un texto al teleprompter
	 */
	setTeleprompter: (datos) => {
		return post('set-teleprompter.php', datos)
	},

	/**
	 * Pasamos a la siguiente fase
	 */
	setSiguienteFase: (datos) => {
		return post('set-siguiente-fase.php', datos)
	},

	cancelarTarea: (idTarea) => {
		const datos = {
			ID_tarea: idTarea
		}
		return post('set-cancela-tarea.php', datos)
	},

	// RECHAZOS DE TAREAS

	/**
	 * Obtenemos los motivos de rechazo de una tarea
	 */
	getMotivosRechazo: () => {
		return get('get-motivos-rechazo.php')
	},

	/**
	 * Rechazar una versión
	 */
	setRechazarVersion: (datos) => {
		return post('set-rechazar-version.php', datos)
	},

	// SOPORTES
	getSoportes: () => {
		return get('get-soportes.php')
	},

	// LOCUTORES

	/**
	 * Obtenemos un listado de procedencias de los locutores
	 */
	getProcedencias: () => {
		return get('get-procedencias.php')
	},

	/**
	 * Creamos una nueva procedencia
	 */
	setProcedencia: (datos) => {
		return post('set-procedencia.php', datos)
	},

	/**
	 * Creamos/editamos un locutor
	 */
	setLocutor: (datos) => {
		return post('set-locutor.php', datos)
	},

	/**
	 * Asigna un locutor a una tarea
	 */
	asignaLocutor: (datos) => {
		return post('asigna-locutor.php', datos)
	},

	/**
	 * Obtiene un listado de locutores habituales
	 */
	getLocutoresHabituales: (tipo, IDAnunciante) => {
		const datos = {
			tipo: tipo,
			ID_anunciante: IDAnunciante
		}
		return post('get-locutores-habituales.php', datos)
	},

	/**
	 * Buscamos locutores
	 */
	queryLocutores: (filtro) => {
		return post('query-locutores.php', filtro)
	},

	// AUDITOR
	getAuditor: (idFichero) => {
		return get('get-auditor.php?ID_fichero=' + idFichero)
	},

	getProgramacion: (idFichero) => {
		return get('get-programacion.php?ID_fichero=' + idFichero)
	},

	getProgramacionPDF: (datos) => {
		return post('get-programacion-pdf.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/produccion/vue/services/api.js